import type { Guia } from '../tipos';

export const guiaAcesso: Guia = {
  id: 'acesso',
  titulo: 'Entrar no sistema, senha e celular',
  resumo:
    'Primeiro acesso, troca de senha, o que fazer se esquecer a senha e como instalar no celular.',
  perfis: 'todos',
  publico: true,
  revisadoEm: '2026-10-17',
  secoes: [
    {
      id: 'entrar',
      titulo: 'Entrar',
      passos: [
        'Abra o endereço do MetaEpi no navegador (Chrome, Edge, Safari ou Firefox).',
        'Digite o **E-mail institucional** e a **Senha** e clique em **Entrar**.',
        'Depois de 5 senhas erradas seguidas, o acesso fica bloqueado por 15 minutos, para proteger a sua conta.',
      ],
      observacao:
        'Por segurança, a sessão termina sozinha depois de 30 minutos sem uso. Antes disso, o sistema avisa e você pode continuar.',
      botoes: ['Entrar'],
      imagem: {
        arquivo: 'acesso-login.png',
        descricao: 'Tela de login com os campos E-mail institucional e Senha e o botão Entrar.',
      },
    },
    {
      id: 'primeiro-acesso',
      titulo: 'Primeiro acesso',
      passos: [
        'Entre com a senha provisória que o administrador do seu município entregou.',
        'Leia o aviso de privacidade, marque **Li e estou ciente** e clique em **Continuar**.',
        'Crie a sua senha pessoal: pelo menos 12 caracteres. Uma frase fácil de lembrar é uma boa senha.',
      ],
      observacao:
        'A senha é pessoal: não compartilhe com colegas. Cada registro fica com o nome de quem fez.',
      botoes: ['Li e estou ciente', 'Continuar'],
      imagem: {
        arquivo: 'acesso-primeiro.png',
        descricao:
          'Tela de primeiro acesso com o aviso de privacidade e a caixa Li e estou ciente.',
      },
    },
    {
      id: 'esqueci',
      titulo: 'Esqueci a senha',
      passos: [
        'Na tela de login, clique em **Esqueci minha senha**.',
        'Se lembra o e-mail cadastrado, escolha **Lembro meu e-mail**, digite o e-mail e clique em **Enviar link**.',
        'Se não lembra, escolha **Não lembro meu e-mail**, preencha nome, contato e unidade e clique em **Pedir ajuda**. O administrador do município entra em contato.',
      ],
      observacao:
        'Enquanto o envio de e-mails não estiver ligado, o administrador gera o link de nova senha no sistema e entrega a você.',
      botoes: ['Esqueci minha senha', 'Enviar link', 'Pedir ajuda'],
    },
    {
      id: 'trocar-senha',
      titulo: 'Trocar a senha',
      passos: [
        'Clique no seu nome, no canto de cima, e em **Trocar senha**.',
        'Digite a **Senha atual**, a **Nova senha** e confirme.',
      ],
      botoes: ['Trocar senha'],
    },
    {
      id: 'celular',
      titulo: 'Instalar no celular',
      passos: [
        '**Android (Chrome):** quando aparecer o aviso "Instale o MetaEpi no seu celular", toque em **Instalar**.',
        '**iPhone (Safari):** toque em **Compartilhar** e depois em **Adicionar à Tela de Início**.',
        'O MetaEpi passa a abrir pelo ícone, em tela cheia, como um aplicativo.',
      ],
      observacao:
        'Nenhum dado de paciente fica guardado no celular: os dados continuam só no servidor.',
      botoes: ['Instalar'],
    },
  ],
};
